<!-- Accordian  -->
<div class="ctm-tab custom-card card-accord">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>
            lblGeneralInfo
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="OnClose()" aria-label="Center Align">
            <span aria-hidden="true">
                ×
            </span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="card pad15">
            <!-- Appointment Details -->
            <div class="row" *ngIf="appointmentDetails">
                <div class="col-6">
                    <div class="row">
                        <div class="col-6">
                            <div class="af-form-group">
                                <label translate>lblAppointmentType</label>
                                <div class="lbl-info">
                                    {{appointmentDetails.appointmentType}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="af-form-group">
                                <label>
                                    <span translate>lblOwner</span> / <span translate>lblUser</span>
                                </label>
                                <div class="lbl-info">
                                    {{appointmentDetails.customerName}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="af-form-group">
                                <label translate>lblDealer</label>
                                <div class="lbl-info">
                                    {{appointmentDetails.dealerName}}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 col-lg-6" >
                            <div class="af-form-group">
                              <label translate>lblSourceCreation</label>
                              <div class="lbl-info">
                                <div class=" flex-wrap sourceBox">
                                  {{appointmentDetails.sourceCreation}}
                                </div>
                              </div>
                            </div>
                          </div>


                        <div class="col-12 col-lg-6">
                            <div class="af-form-group">
                                <label>
                                    <span translate>lblRegNumber</span>
                                </label>
                                <div class="lbl-info">
                                    <div class="flmid flex-wrap">
                                        <div class="licplate LPNo d-flex">
                                            <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                            {{appointmentDetails.licensePlate}}
                                        </div>
                                        <div class="imgWid">
                                            <img af-brand-logo data-type="BRAND" [data-code]="appointmentDetails.companyMakeCode" class="{{appointmentDetails.companyMakeName}}-icon common brandicon" alt="img" />
                                        </div>
                                        <button class="btn btn-link ml-2" (click)="copyTextRegistrationNumber()" placement="top" ngbTooltip="Copy RegitrationNo"
                                            aria-label="Center Align">
                                            <em class="fas fa-copy fa-lg"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="af-form-group">
                                <label translate>lblModel</label>
                                <div class="lbl-info">
                                    {{appointmentDetails.modelName}}
                                </div>
                            </div>
                        </div>
                     
                        <div class="col-6" *ngIf="contactDetails">
                            <div class="af-form-group">
                              <label translate>lbl1stRegistrationDate</label>
                              <div class="lbl-info">
                                {{contactDetails.registrationDate}}
                              </div>
                            </div>
                          </div>
                          <div class="col-6" *ngIf="contactDetails">
                            <div class="form-check pl-0">
                              <label translate>lblMileage</label>
                              <label translate class="form-check-label">(KM)</label>
                              <div class="lbl-info" *ngIf="contactDetails.kilometer; else elseKilometer">
                               {{contactDetails.kilometer}}
                               
                              </div>
                              <ng-template #elseKilometer>
                                <div class="lbl-info">
                                    -
                                </div>
                            </ng-template> 
                            </div>
                          </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-6">
                            <div class="af-form-group">
                                <label>Appointment Status</label>
                                <div class="lbl-info">
                                    <div class="color-box"
                                        [style.background-color]="appointmentDetails.appointmentStatusColor">
                                    </div>
                                    {{appointmentDetails.appointmentStatus}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6" *ngIf="contactDetails">
                            <div class="af-form-group">
                                <label translate>lblBookedDate</label>
                                <div class="lbl-info" *ngIf="appointmentBookedDate">
                                    {{ appointmentBookedDate | date:'short'}}
                                </div>
                            </div>
                        </div>

                        <div class="col-6" *ngIf="contactDetails">
                            <div class="af-form-group">
                                <label>
                                    <span translate>lblWoNo</span>
                                </label>
                                <div class="lbl-info">
                                    # <span class="lbl-info">{{appointmentDetails.workOrderNo}}</span> 
                                    <button class="btn btn-link ml-2" (click)="copyWorkOrderNumber()" placement="top" ngbTooltip="Copy WoNo"
                                        aria-label="Center Align">
                                        <em class="fas fa-copy fa-lg"></em>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="af-form-group">
                                <label translate>lblWoStatus</label>
                                <div class="lbl-info">
                                    <div class="color-box"
                                        [style.background-color]="appointmentDetails.workorderStatusColor">
                                    </div>
                                    {{appointmentDetails.workorderStatus}}
                                </div>
                            </div>
                        </div>

                        <div class="col-6" *ngIf="contactDetails">
                            <div class="af-form-group">
                              <label>
                                <span translate>lblAssignedMechanic</span>
                              </label>
                              <div class="lbl-info">
                                <span class="lbl-info" translate *ngIf="contactDetails.plannedMechanics else elsePlannedMechanics">
                                  {{contactDetails.plannedMechanics}}
                                </span>
                                <ng-template  #elsePlannedMechanics>
                                  <span class="lbl-info" translate>lblNotYetAssigned</span> 
                                </ng-template>
                              </div>
                            </div>
                        </div>
                        <div class="col-6" >
                            <div class="af-form-group">
                              <label>
                                <span translate>lblSalesPerson</span>
                              </label>
                              <div class="lbl-info">
                                -
                              </div>
                            </div>
                          </div>
                          <div class="col-6" >
                            <div class="af-form-group">
                              <label>
                                <span translate>lblAPKDate</span>
                              </label>
                              <div class="lbl-info">
                                -
                              </div>
                            </div>
                          </div>
                          <div class="col-6" *ngIf="contactDetails">
                            <div class="af-form-group">
                              <label translate>lblBookedDate</label>
                              <div class="lbl-info" *ngIf="appointmentBookedDate">
                                {{ appointmentBookedDate | date:'short'}}
                              </div>
                            </div>
                          </div>
                       
                    </div>
                </div>
            </div>
        </div>

        <!-- bg-grey -->
        <div class="card pad15 pb-0">
            <ngb-accordion #a="ngbAccordion" activeIds="first">

                <!-- Services  -->
                <ngb-panel id="second">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                                aria-label="Center Align">
                                lblServices
                                <span class="font16 ml-4 text-left">(<span>
                                        <span translate>lblTotalPrice</span>:
                                        {{workOrderService.totalPrice | number:'1.2-2'}}</span>
                                    <span>,&nbsp;<span translate>lblTotalInvoice</span>:
                                        {{workOrderService.totalInvoicePrice | number:'1.2-2'}}
                                    </span>
                                    <span>,&nbsp;<span translate>lblTotalTime</span>: {{formattedTotalTime}}
                                        <span *ngIf="workOrderService.totalTime" translate>lblhr</span></span>)</span>
                                <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('second')"><em
                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <!-- Demands -->
                        <div class="row">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblDemands</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <th style="width: 5%" scope="col" translate>lblDemand</th>
                                            <th scope="col" translate>lblShortDescription</th>
                                            <th scope="col" translate>lblCustomerRequirement</th>
                                            <th scope="col" class="text-center no-nowrap" style="width: 120px"
                                                translate>
                                                lblWarranty
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 150px">
                                                <span style="width: 150px" class="d-block" translate>Sales
                                                    Price</span><span class="text-sm1" translate>(Incl.
                                                    VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 150px">
                                                <span style="width: 150px" class="d-block" translate>Sum per
                                                    Service</span><span class="text-sm1" translate>(Incl.
                                                    Tax)</span>
                                            </th>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="appointmentServiceDetail.appointmentDemandList?.length>0; else load_else">
                                                <tr *ngFor="let demand of appointmentServiceDetail.appointmentDemandList; let i=index"
                                                    [ngClass]="{'bgColor' :demand.isAdditionallyAdded}">
                                                    <td>{{ demand.demandNo }}</td>
                                                    <td>
                                                        {{demand.shortDescription}}
                                                    </td>
                                                    <td>
                                                        {{demand.customerRequirement}}
                                                    </td>
                                                    <td class="text-center">
                                                        <input type="checkbox" id="Demand{{demand.id}}"
                                                            [(ngModel)]="demand.isInWarranty" [disabled]="true" />
                                                    </td>
                                                    <td class="text-right">{{demand.sumPerService| number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">{{demand.sumPerServiceInclTax |
                                                        number:'1.2-2'}}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>
                                                        lblNoRecordsFound
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Job  -->
                        <div class="row mt-3">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblJob</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <th scope="col" style="width: 5%" translate>lblDemand</th>
                                            <th scope="col" translate>lblJob</th>
                                            <th scope="col" translate>lblDescription</th>
                                            <th scope="col" class="text-right" style="width: 150px"><span
                                                    translate>Total
                                                    Time</span><br><span class="text-sm1" translate>(Hrs)</span></th>
                                            <th scope="col" class="text-right" translate><span translate>Sales
                                                    Price</span><br><span class="text-sm1" translate>(Incl.
                                                    VAT)</span></th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 150px"><span
                                                    style="width: 150px" translate>lblFixedPrice</span></th>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="appointmentServiceDetail.appointmentJobList?.length>0; else load_else">
                                                <tr *ngFor="let job of appointmentServiceDetail.appointmentJobList; let i=index"
                                                    [ngClass]="{'bgColor' :job.isAdditionallyAdded}">
                                                    <td>{{ job.demandNo }}</td>
                                                    <td>{{job.jobId}}</td>
                                                    <td>{{job.description}}</td>
                                                    <td class="text-right">
                                                        {{job.totalTime}}
                                                    </td>
                                                    <td class="text-right">{{job.price| number:'1.2-2'}}</td>
                                                    <td class="text-right">
                                                        {{(job.fixedPrice === null ? 0 :
                                                        job.fixedPrice) |
                                                        number:'1.2-2'}}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Job Details  -->
                        <div class="row mt-3">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblJobDetail</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <th scope="col" style="width: 5%" translate>lblDemand</th>
                                            <th scope="col" style="width: 5%" translate>lblJob</th>
                                            <th scope="col" translate>lblCostType</th>
                                            <th scope="col" translate>lblSalesPart</th>
                                            <th scope="col" translate>lblDescription</th>
                                            <th scope="col" style="width: 130px" class="no-nowrap text-right"><span
                                                    translate>Quantity/Time</span><br><span class="text-sm1"
                                                    translate>(Hrs)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                                    translate>Unit
                                                    Price</span><br><span class="text-sm1" translate>(Excl. VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                                    translate>Sales
                                                    Price</span><br><span class="text-sm1" translate>(Excl. VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px" translate>
                                                <span translate>Sales
                                                    Price</span><br><span class="text-sm1" translate>(Incl.
                                                    VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right" style="width: 150px"><span
                                                    translate>lblFixedPrice</span></th>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="appointmentServiceDetail.appointmentJobDetailList?.length>0; else load_else">
                                                <tr *ngFor="let jobdetail of appointmentServiceDetail.appointmentJobDetailList; let i=index"
                                                    [ngClass]="{'bgColor' :jobdetail.isAdditionallyAdded}">
                                                    <td>{{ jobdetail.demandNo }}</td>
                                                    <td>{{jobdetail.jobId}}</td>
                                                    <td>{{jobdetail.costType}}</td>
                                                    <td>{{jobdetail.salesPart}}</td>
                                                    <td>
                                                        {{jobdetail.description}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{jobdetail.plannedQuantity}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.unitPrice | number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.salesPriceAmount |
                                                        number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.salesPriceAmountVAT |
                                                        number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{(jobdetail.fixedPrice === null ? 0 :
                                                        jobdetail.fixedPrice) |
                                                        number:'1.2-2'}}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>

                <!-- Additional Work  -->
                <ngb-panel id="third">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                                aria-label="Center Align">
                                lblAdditionalWork
                                <ng-container *ngIf="!a.activeIds.includes('third')"><em
                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('third')"><em
                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <!-- Additional work demands -->
                        <div class="row">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblDemands</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <tr>
                                                <th scope="col" translate>lblDemand</th>
                                                <th scope="col" translate>lblDescription</th>
                                                <th scope="col" style="width: 120px" translate>
                                                    lblCustomerRequirement</th>
                                                <th scope="col" class="text-right no-nowrap" style="width: 150px">
                                                    <span style="width: 150px" class="d-block" translate>Sales
                                                        Price</span><span class="text-sm1" translate>(Incl.
                                                        VAT)</span>
                                                </th>
                                                <th scope="col" class="text-right no-nowrap" style="width: 150px">
                                                    <span style="width: 150px" class="d-block" translate>Sum per
                                                        Service</span><span class="text-sm1" translate>(Incl.
                                                        Tax)</span>
                                                </th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblCustomerReply</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblMechanicApproved</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblAdminApproved</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblCDSSApproved</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="additionalWorkDetails?.appointmentAdditionalDemandList?.length>0; else load_else">
                                                <ng-container
                                                    *ngFor="let demand of additionalWorkDetails.appointmentAdditionalDemandList; let i=index"
                                                    class="mb-3">
                                                    <tr>
                                                        <td>{{ demand.demandNo }}</td>
                                                        <td>{{demand.shortDescription}}</td>
                                                        <td>{{demand.customerRequirement}}</td>
                                                        <td class="text-right">{{demand.sumPerService|
                                                            number:'1.2-2'}}
                                                        </td>
                                                        <td class="text-right">{{demand.sumPerServiceInclTax |
                                                            number:'1.2-2'}}</td>

                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="demand.isCustomerApporved !== -1; else additionalworkc_else">
                                                                <input type="checkbox" id="DemandCustomer{{i}}"
                                                                    [(ngModel)]="demand.isCustomerApporved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalworkc_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="demand.isMechanicApproved !== -1; else additionalworkm_else">
                                                                <input type="checkbox" id="DemandMechanic{{i}}"
                                                                    [(ngModel)]="demand.isMechanicApproved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalworkm_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>
                                                        </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="demand.isAdminApproved !== -1; else additionalwork_else">
                                                                <input type="checkbox" id="DemandAdmin{{i}}"
                                                                    [(ngModel)]="demand.isAdminApproved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalwork_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>

                                                        <td translate class="text-center">
                                                            <ng-container
                                                                *ngIf="demand.isCDSSApproved !== -1; else additionalworkr_else">
                                                                <input type="checkbox" id="DemandCdss{{i}}"
                                                                    [(ngModel)]="demand.isCDSSApproved" disabled />

                                                            </ng-container>
                                                            <ng-template #additionalworkr_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="14" class="no-record" translate>lblNoRecordsFound</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Additional work jobs  -->
                        <div class="row">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblJob</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <tr>
                                                <th scope="col" translate>lblDemand</th>
                                                <th scope="col" translate>lblJob</th>
                                                <th scope="col" translate>lblDescription</th>
                                                <th scope="col" class="text-right" style="width: 150px"><span
                                                        translate>Total
                                                        Time</span><br><span class="text-sm1" translate>(Hrs)</span>
                                                </th>
                                                <th scope="col" class="text-right" translate><span translate>Sales
                                                        Price</span><br><span class="text-sm1" translate>(Incl.
                                                        VAT)</span></th>
                                                <th scope="col" class="text-right no-nowrap" style="width: 150px"><span
                                                        style="width: 150px" translate>lblFixedPrice</span></th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblCustomerReply</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblMechanicApproved</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblAdminApproved</th>
                                                <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                    translate>
                                                    lblCDSSApproved</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="additionalWorkDetails?.appointmentAdditionalJobList?.length>0; else load_else">
                                                <ng-container
                                                    *ngFor="let job of additionalWorkDetails.appointmentAdditionalJobList; let i=index"
                                                    class="mb-3">
                                                    <tr>
                                                        <td>{{ job.demandNo }}</td>
                                                        <td>{{job.jobId}}</td>
                                                        <td>{{job.description}}</td>
                                                        <td class="text-right">
                                                            {{job.totalTime}}
                                                        </td>
                                                        <td class="text-right">{{job.price| number:'1.2-2'}}</td>
                                                        <td class="text-right">
                                                            {{(job.fixedPrice === null ? 0 :
                                                            job.fixedPrice) |
                                                            number:'1.2-2'}}
                                                        </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="job.isCustomerApporved !== -1; else additionalworkc_else">
                                                                <input type="checkbox" id="DemandCustomer{{i}}"
                                                                    [(ngModel)]="job.isCustomerApporved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalworkc_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="job.isMechanicApproved !== -1; else additionalworkm_else">
                                                                <input type="checkbox" id="DemandMechanic{{i}}"
                                                                    [(ngModel)]="job.isMechanicApproved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalworkm_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>
                                                        </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="job.isAdminApproved !== -1; else additionalwork_else">
                                                                <input type="checkbox" id="DemandAdmin{{i}}"
                                                                    [(ngModel)]="job.isAdminApproved" disabled />
                                                            </ng-container>
                                                            <ng-template #additionalwork_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>

                                                        <td translate class="text-center">
                                                            <ng-container
                                                                *ngIf="job.isCDSSApproved !== -1; else additionalworkr_else">
                                                                <input type="checkbox" id="DemandCdss{{i}}"
                                                                    [(ngModel)]="job.isCDSSApproved" disabled />

                                                            </ng-container>
                                                            <ng-template #additionalworkr_else><em
                                                                    class="fas fa-times fa-lg"></em>
                                                            </ng-template>

                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="14" class="no-record" translate>lblNoRecordsFound</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Additional work jobDetails  -->
                        <div class="row">
                            <div class="col-12 mb15">
                                <div class="d-flex align-items-center mb-2">
                                    <h4 class="title16" translate>lblJobDetail</h4>
                                </div>
                                <div class="table-responsive border-bottom tableMx-15">
                                    <table class="tablest1">
                                        <thead>
                                            <th scope="col" style="width: 5%" translate>lblDemand</th>
                                            <th scope="col" style="width: 5%" translate>lblJob</th>
                                            <th scope="col" translate>lblCostType</th>
                                            <th scope="col" translate>lblSalesPart</th>
                                            <th scope="col" translate>lblDescription</th>
                                            <th scope="col" style="width: 130px" class="no-nowrap text-right"><span
                                                    translate>Quantity/Time</span><br><span class="text-sm1"
                                                    translate>(Hrs)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                                    translate>Unit
                                                    Price</span><br><span class="text-sm1" translate>(Excl. VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px"><span
                                                    translate>Sales
                                                    Price</span><br><span class="text-sm1" translate>(Excl. VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right no-nowrap" style="width: 130px" translate>
                                                <span translate>Sales
                                                    Price</span><br><span class="text-sm1" translate>(Incl.
                                                    VAT)</span>
                                            </th>
                                            <th scope="col" class="text-right" style="width: 150px"><span
                                                    translate>lblFixedPrice</span></th>
                                            <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                translate>
                                                lblCustomerReply</th>
                                            <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                translate>
                                                lblMechanicApproved</th>
                                            <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                translate>
                                                lblAdminApproved</th>
                                            <th style="width: 100px" class="text-center no-nowrap" scope="col"
                                                translate>
                                                lblCDSSApproved</th>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngIf="additionalWorkDetails?.appointmentAdditionalJobDetailList?.length>0; else load_else">
                                                <tr
                                                    *ngFor="let jobdetail of additionalWorkDetails.appointmentAdditionalJobDetailList; let i=index">
                                                    <td>{{ jobdetail.demandNo }}</td>
                                                    <td>{{jobdetail.jobId}}</td>
                                                    <td>{{jobdetail.costType}}</td>
                                                    <td>{{jobdetail.salesPart}}</td>
                                                    <td>
                                                        {{jobdetail.description}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{jobdetail.plannedQuantity}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.unitPrice | number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.salesPriceAmount |
                                                        number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">{{jobdetail.salesPriceAmountVAT |
                                                        number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{(jobdetail.fixedPrice === null ? 0 :
                                                        jobdetail.fixedPrice) |
                                                        number:'1.2-2'}}
                                                    </td>
                                                    <td class="text-center">
                                                        <ng-container
                                                            *ngIf="jobdetail.isCustomerApporved !== -1; else additionalworkc_else">
                                                            <input type="checkbox" id="DemandCustomer{{i}}"
                                                                [(ngModel)]="jobdetail.isCustomerApporved" disabled />
                                                        </ng-container>
                                                        <ng-template #additionalworkc_else><em
                                                                class="fas fa-times fa-lg"></em>
                                                        </ng-template>

                                                    </td>
                                                    <td class="text-center">
                                                        <ng-container
                                                            *ngIf="jobdetail.isMechanicApproved !== -1; else additionalworkm_else">
                                                            <input type="checkbox" id="DemandMechanic{{i}}"
                                                                [(ngModel)]="jobdetail.isMechanicApproved" disabled />
                                                        </ng-container>
                                                        <ng-template #additionalworkm_else><em
                                                                class="fas fa-times fa-lg"></em>
                                                        </ng-template>
                                                    </td>
                                                    <td class="text-center">
                                                        <ng-container
                                                            *ngIf="jobdetail.isAdminApproved !== -1; else additionalwork_else">
                                                            <input type="checkbox" id="DemandAdmin{{i}}"
                                                                [(ngModel)]="jobdetail.isAdminApproved" disabled />
                                                        </ng-container>
                                                        <ng-template #additionalwork_else><em
                                                                class="fas fa-times fa-lg"></em>
                                                        </ng-template>
                                                    </td>
                                                    <td class="text-center">
                                                        <ng-container
                                                            *ngIf="jobdetail.isCDSSApproved !== -1; else additionalwork_else">
                                                            <input type="checkbox" id="DemandAdmin{{i}}"
                                                                [(ngModel)]="jobdetail.isCDSSApproved" disabled />
                                                        </ng-container>
                                                        <ng-template #additionalwork_else><em
                                                                class="fas fa-times fa-lg"></em>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #load_else>
                                                <tr>
                                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>

                <!-- DWO  -->
                <ngb-panel id="fourth" *ngIf="isDwo">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                                aria-label="Center Align">
                                lblDWO
                                <ng-container *ngIf="!a.activeIds.includes('fourth')"><em
                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('fourth')"><em
                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <app-appointment-dwo></app-appointment-dwo>
                    </ng-template>
                </ngb-panel>

                 <!-- Customer Details -->
                 <ngb-panel id="seventh">
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                                aria-label="Center Align">
                                lblContactDetails
                                <ng-container *ngIf="!a.activeIds.includes('seventh')"><em
                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('seventh')"><em
                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <app-work-order-customer-details [contactDetails]="contactDetails">
                        </app-work-order-customer-details>
                    </ng-template>
                </ngb-panel>

                <!-- Appointment Details -->
                <ngb-panel id="sixth" >
                    <ng-template ngbPanelHeader class="custom-header ctm">
                        <div class="d-flex align-items-center">
                            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                                aria-label="Center Align">
                                lblAppointmentDetails
                                <ng-container *ngIf="!a.activeIds.includes('sixth')"><em
                                        class="fas fa-angle-down fa-lg ml-auto"></em>
                                </ng-container>
                                <ng-container *ngIf="a.activeIds.includes('sixth')"><em
                                        class="fas fa-angle-up fa-lg ml-auto"></em>
                                </ng-container>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <app-work-order-appointment-details [contactDetail]="contactDetails"
                        [appointmentDetails]="appointmentDetails" [isWorkOrderHistory]="true" >
                      </app-work-order-appointment-details>
                    </ng-template>
                </ngb-panel>

            </ngb-accordion>
        </div>
    </div>
</div>